'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactackleCore = require('reactackle-core');

exports.default = {
  row: {
    maxWidth: function maxWidth(_ref) {
      var contentWidth = _ref.contentWidth;
      return contentWidth;
    }
  },

  paddingBox: {
    small: {
      paddingY: _reactackleCore.halfBaseModule,
      paddingX: _reactackleCore.halfBaseModule,

      breakpoints: [{
        breakpoint: function breakpoint(_ref2) {
          var breakpoints = _ref2.breakpoints;
          return breakpoints.medium;
        },
        paddingY: _reactackleCore.baseModule,
        paddingX: _reactackleCore.baseModule
      }]
    },

    medium: {
      paddingY: _reactackleCore.baseModule,
      paddingX: _reactackleCore.baseModule,

      breakpoints: [{
        breakpoint: function breakpoint(_ref3) {
          var breakpoints = _ref3.breakpoints;
          return breakpoints.medium;
        },
        paddingY: _reactackleCore.doubleBaseModule,
        paddingX: _reactackleCore.doubleBaseModule
      }]
    },

    large: {
      paddingY: _reactackleCore.twoAndHalfBaseModule,
      paddingX: _reactackleCore.twoAndHalfBaseModule,

      breakpoints: [{
        breakpoint: function breakpoint(_ref4) {
          var breakpoints = _ref4.breakpoints;
          return breakpoints.medium;
        },
        paddingY: _reactackleCore.fourBaseModule,
        paddingX: _reactackleCore.fourBaseModule
      }]
    }
  },

  container: {
    paddingY: _reactackleCore.baseModule,
    paddingX: _reactackleCore.baseModule,

    breakpoints: [{
      breakpoint: function breakpoint(_ref5) {
        var breakpoints = _ref5.breakpoints;
        return breakpoints.medium;
      },
      paddingY: _reactackleCore.doubleBaseModule,
      paddingX: _reactackleCore.doubleBaseModule
    }, {
      breakpoint: function breakpoint(_ref6) {
        var breakpoints = _ref6.breakpoints;
        return breakpoints.large;
      },
      paddingY: _reactackleCore.tripleBaseModule,
      paddingX: _reactackleCore.tripleBaseModule
    }]
  },

  column: {
    gutterHorizontal: _reactackleCore.baseModule,
    gutterVertical: _reactackleCore.baseModule,

    breakpoints: [{
      breakpoint: function breakpoint(_ref7) {
        var breakpoints = _ref7.breakpoints;
        return breakpoints.medium;
      },
      gutterHorizontal: _reactackleCore.doubleBaseModule,
      gutterVertical: _reactackleCore.doubleBaseModule
    }, {
      breakpoint: function breakpoint(_ref8) {
        var breakpoints = _ref8.breakpoints;
        return breakpoints.large;
      },
      gutterHorizontal: _reactackleCore.tripleBaseModule,
      gutterVertical: _reactackleCore.tripleBaseModule
    }]
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-grid/dist/styles/theme.js
// module id = 694
// module chunks = 0